<template>
  <section class="oauth-login">
    <div class="login-box">
      <!-- <h3>
        账号运营系统
      </h3> -->
      <div class="titleBox">
        <div class="title">账号运营系统</div>
        <div class="titleOld">原媒体自动化系统</div>
      </div>
      <div class="memo">
        {{ loading ? '认证中...' : '认证失效，请重新认证~' }}
      </div>
      <el-button
        type="primary"
        :loading="loading"
        style="width: 40%; border-radius: 40px; background: #06741a;border: none"
        @click="handleLogin"
      >
        认 证
      </el-button>
    </div>
  </section>
</template>

<script>
import { urlApi, loginApi } from '@/api/oauth.js'

export default {
  name: 'Login',
  data() {
    return {
      memo: '认证中...',
      loading: false
    }
  },
  async created() {
    window.localStorage.setItem('origin', this.$route.path)
    const { code, idToken } = this.getHash()
    if (code && idToken) {
      this.loginFun(code, idToken)
      return
    }
    if (this.$route.query.autoLogin == 'true') {
      const url = await this.getUrl()
      if (url) {
        window.location.href = url
      }
    }
  },
  methods: {
    async handleLogin() {
      const url = await this.getUrl()
      if (url) {
        window.location.href = url
      }
    },
    // 登录
    async loginFun(code, idToken) {
      try {
        this.loading = true
        const res = await loginApi({
          code: code,
          id_token: idToken,
          provider_name: this.getProviderName()
        })

        if (res.is_staff) {
          window.localStorage.setItem('roles', 'ADMIN|USER')
        } else {
          window.localStorage.setItem('roles', 'USER')
        }
        localStorage.setItem('userInfo', JSON.stringify(res))
        this.$store.commit('user/SET_INFO')
        window.localStorage.setItem('origin', this.$route.path)
        this.$router.push('/')
      } catch {
        this.loading = false
      }
    },
    //获取登录地址
    async getUrl() {
      try {
        const res = await urlApi(this.getProviderName())
        return res.location
      } catch {
        return ''
      }
    },
    // 获取认证后的url信息
    getHash() {
      const query = new URLSearchParams(this.$route.hash.slice(1))
      const code = query.get('code') || null
      const idToken = query.get('id_token') || null
      return {
        code: code,
        idToken: idToken
      }
    },
    // 获取平台名称
    getProviderName() {
      let name = this.$route.params.providerName
      return name || ''
    }
  }
}
</script>

<style lang="scss" scoped>
.oauth-login {
  background: url('../../assets/loginImages/bg.png') no-repeat;
  background-position: center;
  height: 100%;
  width: 100%;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;

  .login-box {
    border-radius: 15px;
    background-clip: padding-box;
    width: 380px;
    height: 360px;
    //padding: 15px 35px 25px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 25px;

    .titleBox {
      text-align: center;
      background:#06741a;
      color: #fff;
      padding: 20px 0;
      width: 100%;
      border-radius: 5px 5px 0 0;
      .title {
        font-size: 26px;

      }
      .titleOld {
        color: #aab3ab;
      }
    }
    h3 {
      font-size: 22px;
    }

    .memo {
      color: #a2a1a1;
    }
  }
}
</style>
